module.exports = __webpack_public_path__ + "static/media/Nepal.6eeb8e82.png";